import React from "react";
import styles from "./TimelineDot.module.css";

interface TimelineDotProps {
  color: string;
}
export const TimelineDot: React.FC<TimelineDotProps> = ({ color }) => {
  return <div className={styles.dot} style={{ backgroundColor: color }}></div>;
};
